import React, { Component } from 'react';

import ConfigurationManager from '../../configuration/ConfigurationManager';
import URIBuilder from '../../utils/URIBuilder';

import './PDFViewer.css';

const NUXEO_PDF_VIEWER_PATH = '/nuxeo/ui/bower_components/nuxeo-ui-elements/viewers/pdfjs/web/viewer.html';

class PDFViewer extends Component {
  render() {
    const { file } = this.props;

    let uri = new URIBuilder(ConfigurationManager.getProperty('NUXEO_HOST'));
    uri.port = ConfigurationManager.getProperty('NUXEO_PORT');
    uri.path = NUXEO_PDF_VIEWER_PATH;
    uri.addParam('file', file);

    return (
      <iframe title="PDF Viewer" className="pdf-viewer" src={ uri.toString() }/>
    );
  }
}

export default PDFViewer;
